import { render, staticRenderFns } from "./control-button.vue?vue&type=template&id=438d6d19"
import script from "./control-button.vue?vue&type=script&lang=js"
export * from "./control-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports